import { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";

import { getFirmLoginBranding } from "../api/firmLogin";
import { normalizeFirmSlug } from "../auth/firmLogin.mjs";

import LoginPage from "./LoginPage";

const FirmLoginPage = () => {
  const { firmSlug } = useParams();
  const slug = normalizeFirmSlug(firmSlug);
  const [lookup, setLookup] = useState({ slug: null, status: "loading", branding: null });

  useEffect(() => {
    if (!slug) return;
    let active = true;
    getFirmLoginBranding(slug).then(
      (branding) => {
        if (active) setLookup({ slug, status: "ready", branding });
      },
      (error) => {
        if (active)
          setLookup({
            slug,
            status: error.response?.status === 404 ? "not-found" : "error",
            branding: null,
          });
      }
    );
    return () => {
      active = false;
    };
  }, [slug]);

  if (!slug) return <Navigate replace to="/login" />;
  if (lookup.slug !== slug || lookup.status === "loading") {
    return (
      <main className="firm-login-message" role="status">
        Loading firm login…
      </main>
    );
  }
  if (lookup.status !== "ready") {
    return (
      <main className="firm-login-message">
        <h1>
          {lookup.status === "not-found"
            ? "We couldn’t find that firm"
            : "Unable to load this firm’s login"}
        </h1>
        <p>
          {lookup.status === "not-found"
            ? "Check the URL or use the normal login."
            : "Please reload the page and try again."}
        </p>
        <Link to="/login">Go to normal login</Link>
      </main>
    );
  }
  return <LoginPage key={slug} firmSlug={slug} branding={lookup.branding} />;
};

export default FirmLoginPage;
